/**
 * IndexedDB helpers. Local cache only — do NOT mark sync dirty here.
 * Cloud writes go through sessionSync save* / repositories write-through.
 */
export default {
  open() {
    var req = indexedDB.open("weekToDo", 4);
    req.onupgradeneeded = function (event) {
      var db = event.target.result;
      if (!db.objectStoreNames.contains("todo_lists")) {
        db.createObjectStore("todo_lists", { autoIncrement: false });
      }
      if (!db.objectStoreNames.contains("repeating_events")) {
        db.createObjectStore("repeating_events", { autoIncrement: false });
      }
      if (!db.objectStoreNames.contains("repeating_events_by_date")) {
        db.createObjectStore("repeating_events_by_date", { autoIncrement: false });
      }
    };
    req.onerror = function (event) {
      console.log("error opening database " + event.target.errorCode);
    };
    return req;
  },
  get(db, table, id) {
    let tx = db.transaction([table], "readonly");
    let store = tx.objectStore(table);
    return store.get(id);
  },
  add(db, table, id, obj) {
    let tx = db.transaction([table], "readwrite");
    let store = tx.objectStore(table);
    return store.add(obj, id);
  },
  update(db, table, id, obj) {
    let tx = db.transaction([table], "readwrite");
    let store = tx.objectStore(table);
    let new_obj = JSON.parse(JSON.stringify(obj));
    return store.put(new_obj, id);
  },
  delete(db, table, id) {
    let tx = db.transaction([table], "readwrite");
    let store = tx.objectStore(table);
    return store.delete(id);
  },
  selectAll(db, table) {
    let tx = db.transaction([table], "readwrite");
    let store = tx.objectStore(table);
    return store.openCursor();
  },
  clear(db, table) {
    let tx = db.transaction([table], "readwrite");
    let store = tx.objectStore(table);
    return store.clear();
  },
};
